import React from 'react';

import CMSContent from '../CMSContent/index.jsx';

import RestClient from '@scripts/utilities/rest-client.js';

import ChangePassword from './change-password.jsx';
import LogOutEverywhere from './log-out-everywhere.jsx';
import TwoFactorAuthentication from './two-factor-authentication.jsx';


class AccountSecurity extends React.Component {
  constructor(props) {
    super(props);

    this.onLogOutEverywhereClick = this.onLogOutEverywhereClick.bind(this);
    this.onChangePasswordSubmit = this.onChangePasswordSubmit.bind(this);
  }

  onChangePasswordSubmit(formData) {
    return RestClient.post('/wp-json/sbm/v1/user/change-password/', formData);
  }

  onLogOutEverywhereClick() {
    RestClient.post('/wp-json/sbm/v1/user/log-out-everywhere/').then(this.onLogOutSuccess);
  }

  /**
   * after successfully logging out everywhere, refresh the page. This should
   * redirect the user to the login screen.
   */
  onLogOutSuccess() {
    window.location.href = window.location.href;
  }

  render() {
    return (
      <CMSContent>
        <h2>Security Settings</h2>
        <ChangePassword onSubmit={this.onChangePasswordSubmit} />
        <TwoFactorAuthentication />
        <LogOutEverywhere onClick={this.onLogOutEverywhereClick} />
      </CMSContent>
    );
  }
}


export default AccountSecurity;

